var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-img"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""},on:{"load":_vm.imgload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }